module.exports = __webpack_public_path__ + "static/media/IconRedeAgua.38497422.svg";